// 地图信息面板 / 图例 / 页脚的 DOM 辅助函数。
// 元素由 MapComponent 的模板提供,原先以内联脚本挂在 window 上,现改为显式导入。
// 目标元素不存在时(非地图页面)安全地不做任何事。

const byId = (id) => document.getElementById(id)

export function setFooter(text) {
  const el = byId("map-footer")
  if (el) el.innerText = text
}

export function setTitle(text) {
  const span = byId("info-title")?.getElementsByTagName("span")[0]
  if (span) span.innerText = text
}

export function showTitle() {
  const el = byId("info-title")
  if (el) el.style.opacity = "1"
}

export function hideTitle() {
  const el = byId("info-title")
  if (el) el.style.opacity = "0"
}

export function setFullscreenTip(text) {
  const span = byId("fullscreen-tip")?.getElementsByTagName("span")[0]
  if (span) span.innerText = text
}

export function showFullscreenTip() {
  const el = byId("fullscreen-tip")
  if (!el) return
  el.style.opacity = "1"
  el.style.zIndex = "999"
}

export function hideFullscreenTip() {
  const el = byId("fullscreen-tip")
  if (!el) return
  el.style.opacity = "0"
  el.style.zIndex = "-1"
}

export function showTsunamiLegend() {
  const el = byId("tsunami-legend")
  if (!el) return
  el.style.opacity = "1"
  el.style.zIndex = "997"
}

export function hideTsunamiLegend() {
  const el = byId("tsunami-legend")
  if (!el) return
  el.style.opacity = "0"
  el.style.zIndex = "-1"
}

export function showEEWLegend() {
  const el = byId("eew-legend")
  if (!el) return
  el.style.opacity = "1"
  el.style.zIndex = "997"
}

export function hideEEWLegend() {
  const el = byId("eew-legend")
  if (!el) return
  el.style.opacity = "0"
  el.style.zIndex = "-1"
}

export function showInfoLegend() {
  const el = byId("info-legend")
  if (!el) return
  el.style.opacity = "1"
  el.style.zIndex = "997"
}

export function hideInfoLegend() {
  const el = byId("info-legend")
  if (!el) return
  el.style.opacity = "0"
  el.style.zIndex = "-1"
}

export function setTsunamiLegend(alert, warning, notice) {
  const alertEl = byId("alert")
  const warningEl = byId("warning")
  const noticeEl = byId("notice")
  if (alertEl) alertEl.innerText = alert
  if (warningEl) warningEl.innerText = warning
  if (noticeEl) noticeEl.innerText = notice
}

export function setEEWLegend(text) {
  const el = byId("eew")
  if (el) el.innerText = text
}

export function setInfoLegend(text) {
  const el = byId("info-text")
  if (el) el.innerText = text
}
